// src/components/ImageGenerator.jsx

import React, { useRef, useState } from 'react';
import './ImageGenerator.css';
import default_image from '../Assets/default_image.svg';

const ImageGenerator = () => {
    const [imageUrl, setImageUrl] = useState("/");
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);

    const imageGenerator = async () => {
        if (inputRef.current.value === "") return;

        setLoading(true);
        setImageUrl(default_image);

        try {
            const response = await fetch(
                `/api/generate?q=${encodeURIComponent(inputRef.current.value)}`
            );

            if (!response.ok) {
                // This error is from our own server (the 502 error)
                throw new Error(`Server responded with status: ${response.status}`);
            }

            const data = await response.json();

            if (data.image_base64) {
                // Prepend the necessary string to display the base64 image
                const fullImageUrl = `data:image/png;base64,${data.image_base64}`;
                setImageUrl(fullImageUrl);
            } else {
                throw new Error("No image data received from server.");
            }

        } catch (error) {
            console.error("An error occurred during image generation:", error);
            setImageUrl(default_image); // Show default image on any error
        } finally {
            setLoading(false); // Always stop loading
        }
    };

    // ... (rest of your return JSX is fine)
    return (
        <div className='ai-image-generator'>
            <div className="header">AI Image <span>Generator</span></div>
            <div className="img-loading">
                <div className="image">
                    <img src={imageUrl === "/" ? default_image : imageUrl} alt="AI generated art" />
                </div>
                {loading && <div className="loading-overlay">Loading...</div>}
            </div>
            <div className="search-box">
                <input
                    type="text"
                    ref={inputRef}
                    className='search-input'
                    placeholder='Describe what you want to see'
                    onKeyDown={(e) => e.key === 'Enter' && imageGenerator()}
                    disabled={loading}
                />
                <div className={`generate-btn ${loading ? 'disabled' : ''}`} onClick={!loading ? imageGenerator : null}>
                    {loading ? "Generating..." : "Generate"}
                </div>
            </div>
        </div>
    );
}

export default ImageGenerator;